import { render, staticRenderFns } from "./Nice.vue?vue&type=template&id=dfc855a0&scoped=true&"
import script from "./Nice.vue?vue&type=script&lang=js&"
export * from "./Nice.vue?vue&type=script&lang=js&"
import style0 from "./Nice.vue?vue&type=style&index=0&id=dfc855a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc855a0",
  null
  
)

export default component.exports